import React, {useState, useEffect} from "react";
import Config from "./config";
import axios from 'util/Api'

const RemoteJson = (endpoint="") => {

    const [companyLists, setCompanyLists] = useState([]);

    useEffect(() => {
        getAllAccounts();
    }, []);

    const token = localStorage.getItem('token');

    const getAllAccounts = async () => {
        axios.defaults.headers.common['Authorization'] = token;

        return await axios.get(Config.apiserver+endpoint)
            .then((res) => {
                //console.log(res.data);
                if(res.data.status === 1) {
                    if(res.data.data) {
                        setCompanyLists(res.data.data);
                    }
                    else {
                        setCompanyLists(res.data)
                    }
                    // console.log("userData: ",res.data);
                    // setState(res.data.data)
                }
            })
            .catch((error) => {
                console.log(error);
                setCompanyLists([]);
                // setState([]);
            });
    };

    return companyLists;
    // return state;

}

export default RemoteJson;
